import crmApi from "./http-client";

export const leadListService = (uId, searchKey, limit) => {
	const url = `/leads/3d/list`;
	const params = {
		sort: "-createdAt",
		limit,
		"filter[user_id]": uId,
		"filter[search]": searchKey
	};
	return crmApi.get(url, {
		params
	});
};
export const customerListService = (uId, searchKey, limit) => {
	const url = `/customers/3d/list?`;
	const params = {
		sort: "-createdAt",
		limit,
		"filter[user_id]": uId,
		"filter[search]": searchKey
	};
	return crmApi.get(url, {
		params
	});
};
export const saveOqImageService = (formData) => {
	const url = "/files/save-oq-images";
	return crmApi.post(url, formData, {
		headers: {
			"Content-Type": "multipart/form-data"
		}
	});
};
export const leadSourceService = () => {
	const url = `/leads/sources?all=true`;
	return crmApi.get(url);
};
export const createQuoteService = (data) => {
	console.log("data", data);
	const url = `/quotes`;
	return crmApi.post(url, data);
};
export const editQuoteService = (id) => {
	const url = `/quotes/edit?module_id=${id}`;
	return crmApi.get(url);
};
export const updateQuoteService = (data, id) => {
	const url = `/quotes/${id}`;
	return crmApi.patch(url, data);
};
export const createOrderService = (data) => {
	const url = `/orders`;
	return crmApi.post(url, data);
};
export const editOrderService = (id) => {
	const url = `/orders/edit?module_id=${id}`;
	return crmApi.get(url);
};
export const updateOrderService = (data, id) => {
	const url = `/orders/${id}`;
	return crmApi.patch(url, data);
};

export const createInventoryService = (data) => {
	const url = `/inventories`;
	return crmApi.post(url, data);
};
export const editInventoryService = (id) => {
	const url = `/inventories/edit?module_id=${id}`;
	return crmApi.get(url);
};
export const updateInventoryService = (data, id) => {
	const url = `/inventories/${id}`;
	return crmApi.patch(url, data);
};
export const createLeadService = (data) => {
	const url = "/leads";
	return crmApi.post(url, data, {
		"Content-Type": "multipart/form-data"
	});
};
export const createUpdateService = (action, moduleName, payload, id) => {
	const service = {
		order: {
			create: (data) => createOrderService(data),
			update: (data, id) => updateOrderService(data, id)
		},
		quote: {
			create: (data) => createQuoteService(data),
			update: (data, id) => updateQuoteService(data, id)
		},
		inventory: {
			create: (data) => createInventoryService(data),
			update: (data, id) => updateInventoryService(data, id)
		}
	};
	return action === "edit" ? service[moduleName].update(payload, id) : service[moduleName].create(payload);
};

export const kLinkService = (hashValue) => {
	const url = `/quotes/klink`;
	return crmApi.post(url, { hash: hashValue });
};
